<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список ДТП"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-account-card-details"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          ДТП
        </div>
      </template>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        multi-sort
        :footerProps="datatable_footer"
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.number"
                    label="Гос. номер"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.name"
                    label="ФИО"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.doc.series"
                    label="Серия ВУ"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.doc.number"
                    label="Номер ВУ"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.vin"
                    label="VIN"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.phone"
                    label="Номер телефона"
                    @keyup.enter="load"
                  />
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    v-model="form.doc_insurance.series"
                    label="Серия полиса"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.doc_insurance.number"
                    label="Номер полиса"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="form.commissar"
                    :items="select.users"
                    item-value="id"
                    label="Выберите комиссара"
                  >
                    <template v-slot:selection="{item}">
                      <v-list>
                        <v-list-item-content>
                          <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list>
                    </template>
                    <template v-slot:item="{item}">
                      <v-list>
                        <v-list-item-content>
                          <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="2">
                  <v-checkbox
                    v-model="form.deleted"
                    label="Показывать удаленные"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="1">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    color="secondary"
                    dark
                    min-width="250"
                    class="mb-2"
                    @click="clear"
                  >
                    Сбросить фильтры
                  </v-btn>
                </v-col>
                <v-col
                  v-if="$store.state.user.role == 1"
                  cols="6"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    min-width="200"
                    @click="getExcel"
                  >
                    Выгрузить в EXCEL
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
              color="success"
              @click="$router.push('/accident/create/short')"
            >
              <span class="mx-3">
                Создать ДТП
              </span>
            </v-btn>
            </v-card-actions>
          </v-card>
        </template>
        <template v-slot:item.driver="{ item }">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.first.driver.surname }} {{ item.first.driver.name }} {{ item.first.driver.patronymic }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>ВУ {{ item.first.driver.driver_doc.series }} {{ item.first.driver.driver_doc.number }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="item.second"
            two-line
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.second.driver.surname }} {{ item.second.driver.name }} {{ item.second.driver.patronymic }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>ВУ {{ item.second.driver.driver_doc.series }} {{ item.second.driver.driver_doc.number }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item.owner="{ item }">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.first.owner.surname }} {{ item.first.owner.name }} {{ item.first.owner.patronymic }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.first.insurance.doc.series }} {{ item.first.insurance.doc.number }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="item.second"
            two-line
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.second.owner.surname }} {{ item.second.owner.name }} {{ item.second.owner.patronymic }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.second.insurance.doc.series }} {{ item.second.insurance.doc.number }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item.phone="{ item }">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.first.driver.phone }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="item.second">
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.second.driver.phone }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item.vehicle="{ item }">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                {{ item.first.vehicle.model }}, госномер: {{ item.first.vehicle.number }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.first.vehicle.vin }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="item.second"
            two-line
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.second.vehicle.model }}, госномер: {{ item.second.vehicle.number }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.second.vehicle.vin }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item.common="{ item }">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase">
                <span>{{ item.common.date_formatted }} {{ item.common.time }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item.photo="{item}">
          <v-chip :color="get_color(item.photos)">
            {{item.photos.length}}
          </v-chip>
        </template>
        <template v-slot:item.settings="{ item }">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>
                <v-icon
                  color="primary"
                  large
                  class="mr-2"
                  @click="sheetitem = item, sheet = true"
                >
                  mdi-cog
                </v-icon>{{ item.state_text }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.commissar">
                {{ item.commissar.surname }} {{ item.commissar.name }} {{ item.commissar.patronymic }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td colspan="6">
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <v-list-item
                  v-for="(line, index) in item.docs.filter(a=>a.hide!=true)"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-list-item-title class="display-1">
                      {{ line.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon
                        color="grey lighten-1"
                        @click="getDoc(line)"
                      >
                        mdi-content-save
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-model="dialog.show"
      persistent
      scrollable
      max-width="50%"
    >
      <v-card class="elevation-1">
        <v-card-title class="headline">
          Изменение статуса
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container
              grid-list-md
              fluid
            >
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="dialog.item.state"
                    :items="select.state"
                    label="Статус"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn
            color="primary"
            flat
            @click="dialog.show = false"
          >
            Назад
          </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            flat
            min-width="100"
            @click="change_state"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-list>
        <v-list-group v-model="sheetmenu">
          <v-list-item slot="activator">
            <v-list-item-action>
              <v-icon>mdi-build</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Действия</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="show_link_dialog(sheetitem.id)">
            <v-list-tile-content>
              Отправить ссылку на фото
            </v-list-tile-content>
          </v-list-item>
          <v-list-item
            :disabled="($store.state.user.role==4 || $store.state.user.role == 5) || (sheetitem.state != 1 && $store.state.user.role!=1)"
            @click="dialog.item = sheetitem, sheet = false, dialog.show = true"
          >
            <v-list-item-content>
              Изменить статус
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push('/accident/view/' + sheetitem.id)">
            <v-list-item-content>
              Просмотр ДТП
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="($store.state.user.role == 5)"
            @click="$router.push('/contract/list/?accident=' + sheetitem.id)"
          >
            <v-list-item-content>
              Просмотр договоров
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="$store.state.user.role == 5 || sheetitem.state!=1"
            @click="$router.push('/accident/change/' + sheetitem.id)"
          >
            <v-list-item-content>
              Редактировать ДТП
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="$store.state.user.role == 4 || $store.state.user.role == 5 || sheetitem.state!=2"
            @click="$router.push('/contract/create/' + sheetitem.id + '/document')"
          >
            <v-list-item-content>
              Оформление документов
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="$store.state.user.role == 4 || $store.state.user.role == 5 || sheetitem.state!=2"
            @click="$router.push('/contract/create/' + sheetitem.id + '/cession')"
          >
            <v-list-item-content>
              Договор Цессии
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="$store.state.user.role == 4 || $store.state.user.role == 5 || sheetitem.state!=2"
            @click="$router.push('/contract/create/' + sheetitem.id + '/legal')"
          >
            <v-list-item-content>
              Договор юр. услуг
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="$store.state.user.role == 5 || sheetitem.state==3"
            @click="generateFiles(sheetitem.id)"
          >
            <v-list-item-content>
              Перегенерация файлов
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group>
          <v-list-item slot="activator">
            <v-list-item-action>
              <v-icon>mdi-folders</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Документы</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(line, index) in sheetitem.docs.filter(a=>a.hide!=true)"
            :key="index"
            @click="getDoc(line)"
          >
            <v-list-item-content>
              <v-list-item-title class="display-1">
                {{ line.name }} {{ line.created }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-bottom-sheet>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-dialog v-model="link.show" persistent>
      <v-card>
        <v-card-title>Отправка ссылки на загрузку фото</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="link.link" readonly>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="link.phone" label="Телефон">
               </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" min-width=100 @click="link.show = false">
            Закрыть
          </v-btn>
          <v-btn color="primary" min-width=100 @click="send_link">
            Отправить смс
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      overlay: false,
      dialog: {
        show: false,
        item: {},
      },
      link: {
        show: false,
        link: '',
        phone: ''
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {
        docs: [],
      },
      headers: [
        {
          text: 'Действия',
          value: 'settings',
        },
        {
          text: 'Дата и время происшествия',
          value: 'common',
        },
        {
          text: 'Телефоны',
          value: 'phone',
        },
        {
          text: 'Участники',
          value: 'driver',
        },
        {
          text: 'Собственники (страховые полисы)',
          value: 'owner',
        },
        {
          text: 'Автомобили',
          value: 'vehicle',
        },
        {
          text: 'Наличие фото',
          value: 'photo'
        }
      ],
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
        doc: {
          series: '',
          number: '',
        },
        doc_insurance: {
          series: '',
          number: '',
        },
        number: '',
        name: '',
        vin: '',
        phone: '',
      },
      dict: {
        state: {
          1: 'Черновик',
          2: 'Новый',
          3: 'Оформлен',
          4: 'Удален',
        },
      },
      select: {
        state: [
          { value: 1, text: 'Черновик' },
          { value: 2, text: 'Новый' },
          { value: 3, text: 'Оформлен' },
          { value: 4, text: 'Удален' },
        ],
        users: [],
      },
    }),
    mounted: function () {
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      this.axios.post('/api/user/get/', {})
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data
          } else {

          }
        })
        .catch(e => {

        })
      this.load()
    },
    methods: {
      get_color: function(photos) {
        if (!photos || photos.length == 0) return 'red'
        if (photos.length<5) return 'yellow'
        return 'green'
      },
      send_link: function() {
        this.axios.post('/api/photo/sms/', { phone: this.link.phone, link: this.link.link })
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar','Успешно')
            } else {
              this.$store.commit('snackbar', response.data.data || 'Ошибка')
            }
          })
          .catch(e=>{
            this.$store.commit('snackbar', e)
          })
      },
      show_link_dialog: function(id) {
         this.axios.post('/api/photo/link/', { accident: id })
          .then(response => {
            if (!response.data.error) {
              this.link.link = response.data.data
              this.link.phone = ''
              this.link.show = true
            } else {
              this.$store.commit('snackbar', response.data.data || 'Ошибка')
            }
          })
          .catch(e=>{
            this.$store.commit('snackbar', e)
          })
      },
      clear: function () {
        this.form = {
          date: {
            from: '',
            to: '',
          },
          doc: {
            series: '',
            number: '',
          },
          doc_insurance: {
            series: '',
            number: '',
          },
          number: '',
          name: '',
          vin: '',
          phone: '',
        }
        this.form.date.from = moment().format('YYYY-MM-DD')
        this.form.date.to = moment().format('YYYY-MM-DD')
      },
      generateFiles: function (id) {
        this.overlay = true
        this.sheet = false
        this.$axios.post('/api/accident/generate/' + id)
          .then(response => {
            this.overlay = false
            if (!response.data.error) {
              this.load()

              this.$store.commit('snackbar', 'Список файлов обновлен')
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.overlay = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      getDoc: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      getExcel: function () {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/accident/excel',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(this.form),
            name: 'filter',
          })
        )
        form.appendTo('body').submit()
      },
      change_state: function () {
        this.overlay = true
        this.axios.post('/api/accident/state', { id: this.dialog.item.id, state: this.dialog.item.state })
          .then(result => {
            this.overlay = false
            if (!result.data.error) {
              this.dialog.show = false
              this.load()
            }
          })
          .catch(e => {
            this.overlay = false
            this.dialog.show = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load: function () {
        this.overlay = true
        this.axios.post('/api/accident/get', this.form)
          .then(result => {
            this.overlay = false
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              for (let x in this.items) {
                this.items[x].common.date_formatted = moment(this.items[x].common.date).format('DD.MM.YYYY')
                this.items[x].first.driver.birthday = moment(this.items[x].first.driver.birthday).format('DD.MM.YYYY')
                if (this.items[x].second) {
                  this.items[x].second.driver.birthday = moment(this.items[x].second.driver.birthday).format('DD.MM.YYYY')
                }
                this.items[x].state_text = this.dict.state[this.items[x].state]
                console.log(this.items[x].docs)
                for (let y in this.items[x].docs) {
                  if (this.items[x].docs[y].created) this.items[x].docs[y].created = moment(this.items[x].docs[y].created).format('DD.MM.YYYY HH:mm')
                }
              }
            }
          })
          .catch(e => {
            this.overlay = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
